"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var formatPriceCurrency = function formatPriceCurrency(price, currency, locale) {
  var currencyUpperCase = currency.toUpperCase();
  var priceValue = price / 100;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency: currencyUpperCase
  }).format(priceValue);
};

var _default = formatPriceCurrency;
exports["default"] = _default;
//# sourceMappingURL=formatPriceCurrency.js.map